<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>{{data.subtitle}}</div>
<div mat-dialog-actions>
	<button mat-button color="primary" [mat-dialog-close]="false">No</button>
	<button mat-button color="danger" [mat-dialog-close]="true" >Si</button>
</div>
